import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import Button from 'src/components/atoms/Button';
import InputPassword from 'src/components/molecules/InputPassword';
import InputWrap from 'src/components/molecules/InputWrap';
import css from './AccountInformation.module.scss';
import css2 from './shared.module.scss';
import { clearState, nextStep, signup, setStep, setEmail } from 'src/slices/signup';
import { useNavigate } from 'react-router-dom';
import { handleStatus } from 'src/slices/utils';

export default function AccountInformation() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { status } = useSelector((state) => state.signup);

  const [signupCredentials, setSignupCredentials] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmedPassword: '',
  });
  const [policyChecked, setPolicyChecked] = useState(true);

  const signupValidator = (userCredentials) => {
    if (!userCredentials.firstName) {
      toast.warning(`"First Name" is a required field`);
      return null;
    } else if (!userCredentials.lastName) {
      toast.warning(`"Last Name" is a required field`);
      return null;
    } else if (!userCredentials.email) {
      toast.warning(`"Email" is a required field`);
      return null;
    } else if (!userCredentials.password) {
      toast.warning(`"Password" is a required field`);
      return null;
    } else if (
      !userCredentials.confirmedPassword ||
      userCredentials.password != userCredentials.confirmedPassword
    ) {
      toast.warning(`"Password" and "Confirmed Password" must match"`);
      return null;
    }

    if (
      !userCredentials.email.match(
        /^([a-zA-Z0-9_\-\.\+]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/,
      )
    ) {
      toast.warning('Please input a valid email address');
      return null;
    }
    if (userCredentials.password.length < 8) {
      toast.warning('Password must be at least 8 characters long');
      return null;
    }
    if (!policyChecked) {
      toast.warning('You must accept the Privacy Policy and TOS to make an account');
      return;
    }

    return userCredentials;
  };

  const handleNext = () => {
    const user = {
      firstName: signupCredentials.firstName,
      lastName: signupCredentials.lastName,
      email: signupCredentials.email,
      password: signupCredentials.password,
      type: 'merchant',
    };

    if (signupValidator(signupCredentials)) {
      dispatch(signup(user));
    }
  };
  useEffect(() => dispatch(setEmail('')), []);

  useEffect(() => {
    handleStatus(status.signup, () => dispatch(clearState(status.signup)), {
      isSuccess: {
        callback: () => dispatch(nextStep()) && dispatch(setEmail(signupCredentials.email)),
      },
    });
  }, [status]);

  return (
    <>
      <div className={css['inputs']}>
        <InputWrap
          label="Email"
          component={
            <input
              type="email"
              onChange={(e) =>
                setSignupCredentials({
                  ...signupCredentials,
                  email: e.target.value,
                })
              }
              value={signupCredentials.email}
            />
          }
        />
        <InputWrap
          label="First Name"
          component={
            <input
              onChange={(e) =>
                setSignupCredentials({
                  ...signupCredentials,
                  firstName: e.target.value,
                })
              }
              value={signupCredentials.firstName}
            />
          }
        />
        <InputWrap
          label="Last Name"
          component={
            <input
              onChange={(e) =>
                setSignupCredentials({
                  ...signupCredentials,
                  lastName: e.target.value,
                })
              }
              value={signupCredentials.lastName}
            />
          }
        />

        <InputPassword
          label="Password"
          onChange={(e) => setSignupCredentials({ ...signupCredentials, password: e.target.value })}
          value={signupCredentials.password}
          helpText="At least 8 characters"
        />

        <InputPassword
          label="Confirm Password"
          onChange={(e) =>
            setSignupCredentials({
              ...signupCredentials,
              confirmedPassword: e.target.value,
            })
          }
          value={signupCredentials.confirmedPassword}
        />
      </div>

      <div className={css2['buttons']}>
        {/* <Button
					label='Back'
					variant='tertiary'
					color='white'
					iconLeft='fa fa-chevron-left'
					action={() => navigate('/login')}
				/> */}
        <Button
          label="Continue"
          variant="primary"
          color="white"
          iconRight="fa fa-chevron-right"
          action={handleNext}
        />
      </div>

      {/* <ToastContainer /> */}
    </>
  );
}
